import { render, staticRenderFns } from "./ReportTicketsMayoTable.vue?vue&type=template&id=50b39b06&scoped=true&"
import script from "./ReportTicketsMayoTable.vue?vue&type=script&lang=js&"
export * from "./ReportTicketsMayoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b39b06",
  null
  
)

export default component.exports